import React, { ReactNode, useEffect, useRef, useState } from "react";
import ReactSlickLib from "react-slick";

import { useBreakpoint } from "~/shared";
import { SliderArrowButton } from "./SliderArrowButton";

const ReactSlick = ((ReactSlickLib as any).default ??
  ReactSlickLib) as typeof ReactSlickLib;

interface SliderProps {
  title: string;
  items: ReactNode[];
  rows?: number;
  slidesToShow?: number;
}

export const Slider = ({ title, items, rows, slidesToShow }: SliderProps) => {
  const sliderRef = useRef<ReactSlickLib>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const { isMobile } = useBreakpoint();

  const slidesToScroll = 1;
  const mobileSlidesToShow = 1;
  const desktopSlidesToShow = 3;
  const mobileRows = 3;
  const desktopRows = 1;

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow:
      slidesToShow ?? (isMobile ? mobileSlidesToShow : desktopSlidesToShow),
    slidesToScroll,
    arrows: false,
    rows: rows ?? (isMobile ? mobileRows : desktopRows),
    afterChange: (index: number) => setCurrentSlide(index),
  };

  useEffect(() => {
    if (items.length > 0) {
      setIsAtEnd(currentSlide >= items.length - settings.slidesToShow);
    }
  }, [currentSlide, items.length, settings.slidesToShow]);

  const next = () => {
    sliderRef.current?.slickNext();
  };

  const prev = () => {
    sliderRef.current?.slickPrev();
  };

  return (
    <div className="relative my-8 w-full">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="font-ivy text-indigo pl-2 text-3xl font-medium">
          {title}
        </h2>
        <div className="flex gap-2">
          <SliderArrowButton
            onClick={prev}
            ariaLabel="Previous slide"
            variant="primary"
            disabled={currentSlide === 0}
          >
            &larr;
          </SliderArrowButton>
          <SliderArrowButton
            onClick={next}
            ariaLabel="Next slide"
            variant="primary"
            disabled={isAtEnd}
          >
            &rarr;
          </SliderArrowButton>
        </div>
      </div>
      <ReactSlick ref={sliderRef} {...settings}>
        {items.map((item, index) => (
          <div key={index} className="p-2.5 md:px-3 md:pb-0">
            {item}
          </div>
        ))}
      </ReactSlick>
    </div>
  );
};
